import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * Argentine CUIL validator following Single Responsibility Principle
 */
export class CuilValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Argentine CUIL',
      pattern: /^\d{2}-?\d{8}-?\d$/,
      length: 11
    });
  }

  validateFormat(id) {
    const cleanId = id.replace(/-/g, '');
    
    // Check length
    const lengthValidation = this.validateLength(cleanId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'CUIL format must be XX-XXXXXXXX-X or XXXXXXXXXXX'
    );
  }

  validateChecksum(id) {
    const cleanId = id.replace(/-/g, '');
    const digits = cleanId.substring(0, 10);
    const expectedChecksum = ChecksumCalculator.calculateCuilChecksum(digits);
    const actualChecksum = parseInt(cleanId[10]);

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid CUIL checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid CUIL');
  }
}